"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BottomStackPanelPinned = exports.TopStackPanelPinned = exports.RightStackPanelPinned = exports.LeftStackPanelPinned = void 0;
exports.LeftStackPanelPinned = 'leftStackPanelPinned';
exports.RightStackPanelPinned = 'rightStackPanelPinned';
exports.TopStackPanelPinned = 'topStackPanelPinned';
exports.BottomStackPanelPinned = 'bottomStackPanelPinned';
//export const LastLeftStackPanelWidth = "lastLeftStackPanelWidth";
//export const lastRightStackPanelHeight = "lastLeftStackPanelWidth";
//# sourceMappingURL=Constants.js.map